import * as Types from 'src/actions/authentication/register/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import Token from 'src/value-objects/Token';
import { AxiosResponse } from 'axios';
import { RegisterResponse } from 'src/value-objects/RegisterResponse';
import Authentication from 'src/value-objects/Authentication';
import ValidatorService from 'src/services/validation/Validation.service';

export interface RegisterClearErrors extends Action {
  type: Types.REGISTER_CLEAR_ERRORS;
}

export const registerClearErrors: ActionCreator<RegisterClearErrors> = () => (
  { type: Types.REGISTER_CLEAR_ERRORS }
);

export interface RegisterAttempt extends Action {
  type: Types.REGISTER_ATTEMPT;
}

export interface RegisterSuccess extends Action {
  type: Types.REGISTER_SUCCESS;
  payload: Token;
}

export interface RegisterFailure extends Action {
  type: Types.REGISTER_FAILURE;
  payload: {};
}

export type RegisterAction = RegisterAttempt | RegisterSuccess | RegisterFailure | RegisterClearErrors;

export interface RegisterThunk extends ThunkAction<Promise<RegisterAction>, RootState, null> {
}

export const registerAttempt: ActionCreator<RegisterAttempt> = () => (
  { type: Types.REGISTER_ATTEMPT }
);

export const registerSuccess: ActionCreator<RegisterSuccess> = (token: Token) => (
  {
    type: Types.REGISTER_SUCCESS,
    payload: token
  }
);

export const registerFailure: ActionCreator<RegisterFailure> = (error: {}) => (
  {
    type: Types.REGISTER_FAILURE,
    payload: error

  }
);

export const register: ActionCreator<RegisterThunk> = (
  credentials: Authentication
): RegisterThunk => {

  return (dispatch: Dispatch<RootState>): Promise<RegisterAction> => {
    dispatch(registerAttempt());

    return ApiClient.register.create(credentials)
      .then((response: AxiosResponse<RegisterResponse>): RegisterSuccess => {

        const token: Token = new Token({ value: response.data.success.token });

        return dispatch(registerSuccess(token));
      }).catch((response: AxiosResponse<RegisterResponse>): RegisterFailure => {
        const errors = ValidatorService.translateValidations(JSON.parse(response.request.response).errors);
        
        return dispatch(registerFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authentication/register/Register.actions.tsx